<template>
  <div class="w-full p-6">
    <!-- Breadcrumb Navigation -->
    <BreadcrumbNavigation
      :activeView="combinedActiveView"
      @navigate="handleNavigation"
    />
    <h1 class="text-2xl font-bold mb-2">
      {{ combinedActiveView === '' ? 'Administration' : viewTitles[combinedActiveView] }}
    </h1>
    <p class="text-muted-foreground mb-6">{{ combinedActiveView === '' ? 'Manage system settings, user roles, and monitor system activity' : viewSubtitles[combinedActiveView] }}</p>
    
    <!-- Main Administration Dashboard -->
    <AdminDashboard
      v-if="combinedActiveView === ''"
      @navigate="handleNavigation"
    />
    
    <!-- Email Template Management View -->
    <EmailTemplateManagement
      v-if="combinedActiveView === 'email-templates'"
      @navigate="handleNavigation"
    />
    
    <!-- User Role Management View -->
    <UserRoleManagement
      v-if="combinedActiveView === 'user-roles'"
      @navigate="handleNavigation"
    />
    
    <!-- System Configuration View -->
    <SystemConfiguration
      v-if="combinedActiveView === 'system-config'"
      @navigate="handleNavigation"
    />
    
    <!-- Audit Logs View -->
    <AuditLogs
      v-if="combinedActiveView === 'audit-logs'"
      @navigate="handleNavigation"
    />
    
    <!-- Email Template Test View -->
    <EmailTemplateTest
      v-if="combinedActiveView === 'email-template-test'"
      @navigate="handleNavigation"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import BreadcrumbNavigation from '@/components/admin/BreadcrumbNavigation.vue';
import AdminDashboard from '@/components/admin/AdminDashboard.vue';
import EmailTemplateManagement from '@/components/admin/EmailTemplateManagement.vue';
import EmailTemplateTest from '@/components/admin/EmailTemplateTest.vue';
import UserRoleManagement from '@/components/admin/UserRoleManagement.vue';
import SystemConfiguration from '@/components/admin/SystemConfiguration.vue';
import AuditLogs from '@/components/admin/AuditLogs.vue';

export default defineComponent({
  name: 'AdministrationView',
  components: {
    BreadcrumbNavigation,
    AdminDashboard,
    EmailTemplateManagement,
    EmailTemplateTest,
    UserRoleManagement,
    SystemConfiguration,
    AuditLogs
  },
  props: {
    initialView: {
      type: String,
      default: ''
    }
  },
  setup(props) {

    // Define titles for each view
    const viewTitles = {
      'email-templates': 'Email Template Management',
      'email-template-test': 'Email Template Testing',
      'user-roles': 'User Role Management',
      'system-config': 'System Configuration',
      'audit-logs': 'Audit Logs'
    };
    
    // Define subtitles for each view
    const viewSubtitles = {
      'email-templates': 'Create and manage email templates for automated communications',
      'email-template-test': 'Test email templates with variable replacement',
      'user-roles': 'Assign and manage user roles and permissions',
      'system-config': 'Configure system-wide settings and parameters',
      'audit-logs': 'View system activity and user action logs'
    };
    
    // Create a local ref to track navigation within the component
    const localView = ref('');
    
    // Combine the local view with the initialView prop
    const combinedActiveView = computed(() => {
      return localView.value || props.initialView || '';
    });
    
    function handleNavigation(view: string) {
      localView.value = view;
    }
    
    return {
      combinedActiveView,
      viewTitles,
      viewSubtitles,
      handleNavigation
    };
  }
});
</script>
